// Attendance status mapping (1-5) - supports both numeric and string keys from API
const ATTENDANCE_PRESENT = { label: 'Present', color: 'bg-emerald-50 dark:bg-transparent text-emerald-700 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-600', description: 'Student attended class on time' };
const ATTENDANCE_LATE = { label: 'Late', color: 'bg-amber-50 dark:bg-transparent text-amber-700 dark:text-amber-400 border border-amber-200 dark:border-amber-600', description: 'Student arrived late to class' };
const ATTENDANCE_CANCELED = { label: 'Canceled', color: 'bg-slate-50 dark:bg-transparent text-slate-600 dark:text-slate-400 border border-slate-200 dark:border-slate-600', description: 'Class was canceled' };
const ATTENDANCE_ABSENT = { label: 'Absent', color: 'bg-rose-50 dark:bg-transparent text-rose-700 dark:text-rose-400 border border-rose-200 dark:border-rose-500', description: 'Student was absent from class' };

export const ATTENDANCE_STATUS = {
  1: ATTENDANCE_PRESENT,
  2: ATTENDANCE_LATE,
  3: ATTENDANCE_CANCELED,
  4: ATTENDANCE_ABSENT,
  5: ATTENDANCE_LATE,
};

// Homework submission status - supports various key formats from API
const HOMEWORK_ON_TIME = { label: 'HW: On Time', color: 'bg-emerald-50 dark:bg-transparent text-emerald-700 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-600', description: 'Homework submitted before deadline' };
const HOMEWORK_LATE = { label: 'HW: Late', color: 'bg-amber-50 dark:bg-transparent text-amber-700 dark:text-amber-400 border border-amber-200 dark:border-amber-600', description: 'Homework submitted after deadline' };
const HOMEWORK_MISSING = { label: 'HW: Not Submitted', color: 'bg-rose-50 dark:bg-transparent text-rose-700 dark:text-rose-400 border border-rose-200 dark:border-rose-500', description: 'Homework not submitted' };

// Separate badge for homework assignment (shown when homework exists)
export const HOMEWORK_ASSIGNED_BADGE = { label: 'HW Assigned', color: 'bg-blue-50 dark:bg-transparent text-blue-700 dark:text-blue-400 border border-blue-200 dark:border-blue-600', description: 'Homework assigned for this module' };

// Status only shows for submission states (not for pending)
export const HOMEWORK_STATUS = {
  'on-time': HOMEWORK_ON_TIME,
  'On-Time': HOMEWORK_ON_TIME,
  'ON-TIME': HOMEWORK_ON_TIME,
  'ontime': HOMEWORK_ON_TIME,
  'late': HOMEWORK_LATE,
  'Late': HOMEWORK_LATE,
  'LATE': HOMEWORK_LATE,
  'no-submission': HOMEWORK_MISSING,
  'No-Submission': HOMEWORK_MISSING,
  'NO-SUBMISSION': HOMEWORK_MISSING,
  'missing': HOMEWORK_MISSING,
  'Missing': HOMEWORK_MISSING,
  // 'pending' intentionally omitted - use HOMEWORK_ASSIGNED_BADGE instead
};

// Video watched status (support both boolean and numeric values from API)
const VIDEO_WATCHED_CONFIG = { label: 'Watched', color: 'bg-emerald-50 dark:bg-transparent text-emerald-700 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-600', description: 'Class recording has been watched' };
const VIDEO_NOT_WATCHED_CONFIG = { label: 'Not Watched', color: 'bg-rose-50 dark:bg-transparent text-rose-700 dark:text-rose-400 border border-rose-200 dark:border-rose-500', description: 'Class recording not yet watched' };

export const VIDEO_STATUS = {
  true: VIDEO_WATCHED_CONFIG,
  false: VIDEO_NOT_WATCHED_CONFIG,
  1: VIDEO_WATCHED_CONFIG,
  0: VIDEO_NOT_WATCHED_CONFIG,
};
